/**
 * A wrapper for Object.keys() that makes the return value type
 * to be (keyof T)[], which Object.keys doesn't do as default.
 *
 * NOTE: There is a reason Object.keys doesn't behave this way:
 * https://vladimirzdrazil.com/posts/object-keys-keyof-t/#:~:text=TLDR,the%20limitations%20when%20using%20it.
 *
 * This is safe to use only for "normal" plain objects, not instances, proxies, etc.
 */
export default function getKeys<T extends object>(obj: T): (keyof T)[] {
  return Object.keys(obj) as (keyof T)[];
}
